import styled, { css } from 'styled-components';
import { scale020, scale030 } from '@xingternal/tokens';
// *** Components ***
export const Container = styled.div `
  display: flex;
  flex-shrink: 0;

  ${({ $size }) => $size === 'small' &&
    css `
      gap: ${scale020};
    `};
  ${({ $size }) => $size === 'medium' &&
    css `
      gap: ${scale030};
    `};
`;
//# sourceMappingURL=skeleton-facepile.styles.js.map